import services from './module';

services.factory('$exceptionHandler', ($log: ng.ILogService) => {
    return ((exception, cause) => {
        if ((exception as any).startsWith && (exception as any).startsWith('Possibly unhandled rejection')) {
            console.info(exception, cause);
        } else {
            if (!options.isProduction && _ && _.notification) {
                _.notification.showError('Exception: ' + exception);
            }
            $log.error(exception, cause);
        }
    }) as ng.IExceptionHandlerService;
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/ExceptionHandler.ts